import './Message.scss';

export const Message = ({Icon, description}) => {

    return (
        <div className={"message"}>
            <div className={"message_container"}>
                <div className={"message_icon"}>
                    {Icon && <Icon style={{fontSize: "60px", color: "#ff9800"}}/>}
                </div>
                <div className={"message_description"}>
                    {description}
                </div>
            </div>
        </div>
    )
}